import {
  BookOpenCheck, Briefcase, Building2, Cog, FlaskConical, HandCoins, Inbox, Landmark,
  MessageCircle,
} from "lucide-react";

export const FISCAL_YEARS = [2026, 2025, 2024, 2023];

// Entrées top-level du menu : chaque entrée mène à un Hub (le Dashboard = « Accueil » du fil d'Ariane).
export const NAV_GROUPS = [
  { id: "cabinet",   label: "Cabinet",                  icon: Briefcase,       path: "/admin/cabinet",  children: null },
  { id: "fiscal",    label: "Fiscal",                   icon: Landmark,        path: "/admin/fiscal",   children: null },
  { id: "paie",      label: "Paie",                     icon: HandCoins,       path: "/admin/paie",     children: null },
  { id: "tenue-livres", label: "Tenue de livres",       icon: BookOpenCheck,   path: "/admin/tenue-livres", children: null },
  { id: "immeubles", label: "Immeubles",                icon: Building2,       path: "/admin/immeubles", children: null },
  { id: "pms",       label: "Files PMS",                icon: Inbox,           path: "/admin/pms-queue", children: null },
  { id: "comms",     label: "Centre de communications", icon: MessageCircle,   path: "/admin/documents", children: null },
  { id: "settings",  label: "Paramètres",               icon: Cog,             path: "/admin/settings",  children: null },
  { id: "test",      label: "Labo (idées)",             icon: FlaskConical,    path: "/admin/test",      children: null },
];

export const CLIENT_TYPES = [
  { id: "particulier", label: "Particulier" },
  { id: "travailleur_autonome", label: "Travailleur autonome" },
  { id: "proprietaire_immeuble", label: "Particulier avec immeuble a revenu" },
  { id: "micro_entreprise", label: "Micro entreprise" },
];

export const DOSSIER_STATUSES = [
  { id: "nouveau", label: "Nouveau", color: "bg-blue-100 text-blue-700" },
  { id: "en_attente_documents", label: "En attente", color: "bg-yellow-100 text-yellow-700" },
  { id: "incomplet", label: "Incomplet", color: "bg-orange-100 text-orange-700" },
  { id: "pret_a_traiter", label: "Pret", color: "bg-teal-100 text-teal-700" },
  { id: "en_cours", label: "En cours", color: "bg-indigo-100 text-indigo-700" },
  { id: "termine", label: "Termine", color: "bg-green-100 text-green-700" },
  { id: "transmis", label: "Transmis", color: "bg-emerald-100 text-emerald-700" },
  { id: "ferme", label: "Ferme", color: "bg-gray-100 text-gray-600" },
];

export const EXPENSE_CATEGORIES = [
  { id: "fournitures", label: "Fournitures" },
  { id: "bureau_domicile", label: "Bureau a domicile" },
  { id: "telephone", label: "Telephone" },
  { id: "internet", label: "Internet" },
  { id: "vehicule", label: "Vehicule" },
  { id: "repas", label: "Repas" },
  { id: "achats", label: "Achats" },
  { id: "loyer", label: "Loyer" },
  { id: "assurance", label: "Assurance" },
  { id: "comptabilite", label: "Comptabilite" },
  { id: "formation", label: "Formation" },
  { id: "publicite", label: "Publicite" },
  { id: "equipement", label: "Equipement" },
  { id: "logiciels", label: "Logiciels" },
  { id: "deplacement", label: "Deplacement" },
  { id: "frais_bancaires", label: "Frais bancaires" },
  { id: "sous_traitance", label: "Sous-traitance" },
  { id: "autre", label: "Autre" },
];
